import Link from "next/link";

/** Brand lockup: the tiger-head mark (public/tiger.svg) + the split wordmark twoke.io. A soft
 *  yellow drop-shadow-sm ties the mark into the design system's single brand hue (SKILL §1).
 *  Clickable → home ("/"; a signed-in user is redirected on to their dashboard). */
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      href="/"
      aria-label="Twoke.IO — home"
      className="flex items-center gap-2.5 transition-opacity hover:opacity-80"
    >
      {/* `tiger-mark` paints a WHITE silhouette of the tiger's own shape behind it on the dark
          theme (globals.css) — the artwork is black ink and vanished into the dark background. */}
      <span className="tiger-mark shrink-0">
        {/* eslint-disable-next-line @next/next/no-img-element -- static brand SVG, no optimization needed */}
        <img
          src="/tiger.svg"
          alt="Twoke.IO tiger"
          width={34}
          height={34}
          style={{ filter: "drop-shadow(0 0 9px rgb(250 204 21 / 0.35))" }}
        />
      </span>
      {!compact && (
        <span className="text-[15px] font-semibold tracking-tight">
          Twoke<span className="text-yellow">.IO</span>
        </span>
      )}
    </Link>
  );
}
